import { render } from "./simpeg-pegawai-add.vue?vue&type=template&id=5635d9a2"
import script from "./simpeg-pegawai-add.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-add.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-add.vue?vue&type=style&index=0&id=5635d9a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__